/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseComponent from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import LoadingAlert from "./LoadingAlert";
import { SidebarGlobal } from "./_Sidebar";
import User from "./User";
import withParams from "./WithParams";
import { qreq } from "../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import MessageDialog from "./MessageDialog";
import L from "./Lang";
import AppActions from "./AppActions";

class UsersEdit extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                roles: [],
                accounts: []
            },
            saving: false
        };
        if (this.props.params.id) {
            this.id = this.props.params.id;
            this.state.loading = true;
        }

        this.submit = this.submit.bind(this);

    }

    componentDidMount() {
        if (this.props.params?.id) {
            qreq.get('/api/user/view/' + this.id, j => {
                if (j.errorCode)
                    alert(j.errorMessage);
                else {
                    this.state.item = j.item;
                    this.setState({ item: this.state.item });
                }
                this.setState({ loading: false });
            }, e => {
                this.goBack();
            });
        }
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    submit(e) {
        e.preventDefault();
        this.setState({ saving: true });

        var item = { ...this.state.item };

        if (!item.serviceGroupID)
            item.serviceGroupID = 0;

        if (!item.organizationID)
            item.organizationID = 0;

        if (!item.primaryAccountID)
            item.primaryAccountID = 0;
        else
            item.primaryAccountID = parseInt(item.primaryAccountID);


        qreq.post('/api/user/save', item, (j) => {
            if (j.errorCode !== 0)
                this.alert(j.errorMessage);
            else {
                this.success('Saved!');
                this.goBack();
            }

            this.setState({ saving: false });
        }, () => {
            this.unkownErrorCallback();
            this.setState({ saving: false });
        });
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }


    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Edit User</L></h1><LoadingAlert /></div>);

        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-success d-none d-md-block" onClick={() => document.getElementById('c-submit').click()}><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button></>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1><L>Edit User</L></h1>
                <Breadcrumb path={[['Users', '/user/list'], ['Edit']]} />
                <AppActions>
                    <button type="button" className="btn btn-success btn-lg" onClick={() => document.getElementById('c-submit').click()}><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button>
                </AppActions>
                <User
                    item={this.state.item}
                    edit={true}
                    onChange={this.change}
                    onRoleChange={roles => this.setState({ item: { ...this.state.item, roles: roles } })} />
                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>

                    <div className="d-none">
                        <button id="c-submit" type="submit" className="btn btn-success d-inline-block"><L>Save</L></button>
                        <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}><L>Cancel and Go Back</L></button>
                    </div></>)}
            </form>
        </div>;
    }
}

export default withParams(UsersEdit);